var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeasons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#3E2952"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5228 53.8188L40.3637 31.1134M32.7953 53.8188L31.9543 31.1134M42.8866 53.8188H29.4315M42.8866 31.1134H29.4315M26.0677 31.1134C26.0677 31.1134 25.2268 28.5906 26.4882 27.3292C27.7496 26.0678 30.2724 26.4882 30.2724 26.4882C30.2724 26.4882 30.2724 23.9654 31.9543 23.1245C33.6362 22.2835 36.159 23.5449 36.159 23.5449C36.159 23.5449 37.8409 20.7219 40.3637 21.4426C42.8866 22.1633 42.8866 25.2268 42.8866 25.2268C42.8866 25.2268 44.9889 25.2268 46.2503 26.9087C47.5117 28.5906 46.2503 31.1134 46.2503 31.1134M45.1537 51.185L49.6141 31.1134H22.704L27.1643 51.185C27.4452 52.4472 27.5848 53.0788 28.0465 53.4488C28.5073 53.8188 29.154 53.8188 30.4482 53.8188H41.869C43.1632 53.8188 43.8099 53.8188 44.2707 53.4488C44.7324 53.0788 44.872 52.4481 45.1537 51.185Z",
    stroke: "#F7F7F7",
    strokeWidth: 2.95987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasons);
export default __webpack_public_path__ + "static/media/seasons.765dd855011aa311634ad22f98303ac5.svg";
export { ForwardRef as ReactComponent };